import { render, staticRenderFns } from "./TemperatureViolationsChart.vue?vue&type=template&id=2a32f06b&scoped=true&"
import script from "./TemperatureViolationsChart.vue?vue&type=script&lang=js&"
export * from "./TemperatureViolationsChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a32f06b",
  null
  
)

export default component.exports